var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-hcaptcha',{attrs:{"sitekey":"3e251ea3-6db0-4aa1-b668-ae4d255f2a3e"}})}
var staticRenderFns = []

export { render, staticRenderFns }